import { Routes } from "@angular/router";
import { KnowledgeBasesPageComponent } from "./pages/knowledge-base/knowledge-base-page.component";
import { KnowledgeBaseSelectWrapperComponent } from "./pages/knowledge-base/knowledge-base-select-wrapper.component";
import { CallbackComponent } from "./shared/components/auth/callback/callback.component";
import { ChatbotChatPageComponent } from "./pages/chatbot/chat/chat-page.component";
import { AutomatedTestsPageComponent } from "./pages/automated-tests/automated-tests-page.component";
import { UserManagementComponent } from "./pages/user-management/user-management.component";
import { ChatbotInteractionComponent } from "./pages/chatbot-interaction/chatbot-interaction.component";
import { ConversationViewerPageComponent } from "./pages/conversation-viewer/conversation-viewer-page.component";
import { ChatbotSelectWrapperComponent } from "./pages/conversation-viewer/chatbot-select-wrapper.component";
import { ChatbotManagementComponent } from "./pages/chatbot-management/chatbot-management.component";
import { HomePageComponent } from "./pages/home/home-page.component";
import { rbacGuard } from "./core/guards/rbac.guard";
import { authGuard } from "./core/guards/auth.guard";

export const routes: Routes = [
    {
        path: 'auth/callback',
        component: CallbackComponent
    },
    { path: "", redirectTo: "home", pathMatch: "full" },
    { path: "home", component: HomePageComponent },
    { path: "automatedtest", component: AutomatedTestsPageComponent },
    {
        path: "chatbot",
        children: [
            {
                path: '',
                component: ChatbotInteractionComponent,
                canActivate: [authGuard, rbacGuard]
            },
            {
                path: 'chats',
                children: [
                    {
                        path: '',
                        component: ChatbotInteractionComponent,
                        canActivate: [authGuard, rbacGuard]
                    },
                    {
                        path: ':code',
                        component: ChatbotChatPageComponent,
                        canActivate: [authGuard, rbacGuard]
                    },
                ],
            },
            {
                path: 'conversations',
                children: [
                    {
                        path: '',
                        component: ChatbotSelectWrapperComponent,
                        canActivate: [authGuard, rbacGuard]
                    },
                    {
                        path: ':botId',
                        component: ConversationViewerPageComponent,
                        canActivate: [authGuard, rbacGuard]
                    },
                ],
            },
        ],
    },
    {
        path: "management",
        children: [
            {
                path: 'chatbot',
                component: ChatbotManagementComponent,
                canActivate: [authGuard, rbacGuard]
            },
            {
                path: 'user',
                component: UserManagementComponent,
                canActivate: [authGuard, rbacGuard]
            },
        ],
    },
    {
        path: "knowledge-base",
        children: [
            {
                path: '',
                component: KnowledgeBaseSelectWrapperComponent,
                canActivate: [authGuard, rbacGuard]
            },
            {
                path: ':code',
                component: KnowledgeBasesPageComponent,
                canActivate: [authGuard, rbacGuard]
            },
            {
                path: ':code/synchronizations',
                loadComponent: () => import('./pages/knowledge-base/knowledge-base-sync/knowledge-base-sync.component').then(m => m.KnowledgeBaseSyncComponent),
                canActivate: [authGuard, rbacGuard]
            },
            {
                path: ':code/synchronizations/:syncId',
                loadComponent: () => import('./pages/knowledge-base/knowledge-base-sync-detail/knowledge-base-sync-detail.component').then(m => m.KnowledgeBaseSyncDetailComponent),
                canActivate: [authGuard, rbacGuard]
            },
            {
                path: ':code/imports',
                loadComponent: () => import('./pages/knowledge-base/knowledge-base-import/knowledge-base-import.component').then(m => m.KnowledgeBaseImportComponent),
                canActivate: [authGuard, rbacGuard]
            },
            {
                path: ':code/imports/history',
                loadComponent: () => import('./pages/knowledge-base/knowledge-base-import-history/knowledge-base-import-history.component').then(m => m.KnowledgeBaseImportHistoryComponent),
                canActivate: [authGuard, rbacGuard]
            },
            {
                path: ':code/imports/:jobId',
                loadComponent: () => import('./pages/knowledge-base/knowledge-base-import-detail/knowledge-base-import-detail.component').then(m => m.KnowledgeBaseImportDetailComponent),
                canActivate: [authGuard, rbacGuard]
            }
        ],
    },
    { path: "**", redirectTo: "chatbot" }
];
